module.exports = __webpack_public_path__ + "assets/images/header.91bb34eea15bc593df3a37b9131861af.svg";